<script>
import config from "@/config.js";
import { bus } from "@/main.js";
import debounce from "lodash/debounce";
const CrossStorageClient = require("cross-storage").CrossStorageClient;
export default {
  data() {
    return {
      frontendRoles: ["doctor", "allied", "patient"],
      appLoading: true
    };
  },
  computed: {
    completedProfile: function () {
      return (
        this.$store.state.user.info &&
        this.$store.state.user.info.completed_profiles
      );
    }
  },
  methods: {
    async getRemoteData() {
      const storage = new CrossStorageClient(
        `${config.NEW_BASE_URL}cross-storage-hub`
      );
      await storage
        .onConnect()
        .then(() => {
          return storage.get(
            "token",
            "currentRole",
            "userInfo",
            "redirectionUrl",
            "currentLocation",
            "publicRouteFrom",
            "ParentToken",
            "ParentInfo"
          );
        })
        .then(async res => {
          if(res[6]) {
            await this.$store.dispatch("user/setParentToken", res[6]);
            await this.$store.dispatch("user/saveParentInfo", res[7]);
          }else {
            localStorage.removeItem("ParentToken");
            localStorage.removeItem("ParentInfo");
          }
          if (res[0]) {
            await this.$store.dispatch("user/setToken", res[0]);
            await this.$store.dispatch("user/setCurrentRole", res[1]);
            await this.$store.dispatch(
              "user/saveUserDetails",
              JSON.parse(res[2])
            );
            localStorage.setItem(
              "redirectionUrl",
              res[3] !== "null" ? res[3] : null
            );
            await storage.del("redirectionUrl");
            await this.$store.dispatch(
              "user/setCurrentLocation",
              JSON.parse(res[4])
            );
            await localStorage.setItem("publicRouteFrom", res[5]);
            await this.$store.dispatch("user/setLoggedIn", true);
          } else this.clearLoggedInData();
          this.appLoading = false;
        })
        .catch(err => {
          console.log(err);
          setTimeout(() => {
            this.getRemoteData();
          }, 800);
        });
    },
    logout() {
      try {
        let url = `${config.NEW_BASE_URL}api/v2/logout`;
        this.$http.get(url).then(response => {
          if (response.status) {
            this.clearLoggedInData();
          }
        });
      }
      catch(e) {
        console.log(e);
        this.clearLoggedInData();
      }
    },
    clearLoggedInData() {
      const storage = new CrossStorageClient(
        `${config.NEW_BASE_URL}cross-storage-hub`
      );                     
      storage
        .onConnect()
        .then(() => {
          return storage.clear();
        })
        .catch(err => {
          console.log(err);
        })
        .then(() => {
          storage.close();
          this.$store.dispatch("user/logout");
          this.$transport.close();
          window.location.href = config.NUXT_URL;
        });
    },
    //Auto redirect to project according to current role
    redirectToProject: debounce(async function (path) {
      const storage = new CrossStorageClient(
        `${config.NEW_BASE_URL}cross-storage-hub`
      );

      await storage.onConnect();
      const token = await storage.get("token");
      const currentRole = await storage.get("currentRole");
      const userInfo = await storage.get("userInfo");
      storage.close();

      if (!token) {
        if (path === "/") this.clearLoggedInData();
      } else {
        if (path === "/" || !this.frontendRoles.includes(currentRole)) {
          bus.$emit("callHandelRedirect", currentRole, JSON.parse(userInfo));
        }
      }
    }, 800),
  }
};
</script>
